import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
interface UseSlideshowConfigReturn {
  slidesPerView: number;
}
export function useSlideshowConfig() {
  const $ = _c(4);
  const getSlidesPerView = _temp;
  const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView());
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleResize = () => {
        setSlidesPerView(getSlidesPerView());
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t1 = [getSlidesPerView];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== slidesPerView) {
    t2 = {
      slidesPerView
    };
    $[2] = slidesPerView;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp() {
  if (window.innerWidth > 1200) {
    return 4;
  } else {
    if (window.innerWidth > 500) {
      return 2;
    }
  }
  return 1;
}